import { Button, Switch, Modal, Typography, InputNumber } from "antd";

const ModifyBatchConfigModal = ({
  isModalOpen = false,
  batchConfig = {},
  setIsModalOpen = () => {},
  handleBatchConfigStateUpdate = () => {},
  handleUpdateBatchConfig = () => {}
}) => {
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleUpdate = () => {
    handleUpdateBatchConfig(batchConfig);
  };

  return (
    <Modal
      title="Modify Batch Config"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleUpdate}>
          Update Config
        </Button>
      ]}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "16px" }}>
        {Object.keys(batchConfig || {}).map((key) => {
          if (key === "_id") {
            return null;
          }
          const value = batchConfig[key];

          if (key === "subscriptionsLimit") {
            return (
              <div
                key={key}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 12px",
                  borderRadius: "4px"
                }}
              >
                <Typography.Text strong>{key}</Typography.Text>
                <InputNumber
                  min={0}
                  value={value}
                  onChange={(val) => {
                    handleBatchConfigStateUpdate(key, val);
                  }}
                />
              </div>
            );
          }

          return (
            <div
              key={key}
              role="button"
              tabIndex={0}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                padding: "8px 12px",
                borderRadius: "4px",
                transition: "background-color 0.2s"
              }}
              onClick={() => {
                handleBatchConfigStateUpdate(key, !value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  handleBatchConfigStateUpdate(key, !value);
                  e.preventDefault();
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.02)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
              }}
            >
              <Typography.Text strong>{key}</Typography.Text>
              <Switch
                checked={value}
                onChange={(checked) => {
                  handleBatchConfigStateUpdate(key, checked);
                }}
              />
            </div>
          );
        })}
      </div>
    </Modal>
  );
};
export default ModifyBatchConfigModal;
